import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataSteering } from '@/features/equipments/types/equipmentModelLatestFipe'

interface FipeDirectionAccordionProps {
  steeringData?: EquipmentModelLatestFipeDataSteering
}

export default function FipeDirectionAccordion({ steeringData }: FipeDirectionAccordionProps) {
  return (
    <Accordion
      name="Direction"
      head="Direção"
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Assistência" 
            value={steeringData?.Assistencia} 
          />
          <InfoField 
            label="Diâmetro de Giro" 
            value={steeringData?.["Diametro Giro"]} 
          />
        </div>
      }
    />
  )
}